/**
 * 我的关注与粉丝
 * @returns
 */
import {
  Box,
  Image,
  Tabs,
  TabList,
  Tab,
  TabIndicator,
  TabPanels,
  TabPanel,
  InputGroup,
  InputRightElement,
  Input,
  Flex,
  HStack,
  Text,
  Select,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { SlMagnifier } from "react-icons/sl";
import MyFollowing from "@/components/usercenter/myfollowing";
import { useSelector, useDispatch } from "react-redux";
import { updateUser, selectUser } from "@/reducer/userslice";
import { ServerError } from "@/types/errors";
import {
  useLazyGetFollowsQuery,
  useLazyGetFansQuery,
  useLazyGetBlackListQuery,
  useCreateFollowMutation,
  useDeleteFollowMutation,
  useUpdateFollowMutation,
  useUpdateFansMutation,
} from "@/services/api/endpoints/follow";
import { Follow } from "@/types/follow";
import emptyImg from "@/assets/images/empty.png";

const FollowAndFans = () => {
  const user = useSelector(selectUser);
  // console.log(user);
  const toast = useToast();
  const [searchValue, setSearchValue] = useState("");
  const [tabIndex, setTabIndex] = useState<number>(0);

  const [getFollows, { data: followersList }] = useLazyGetFollowsQuery();
  const [getFans, { data: fansList }] = useLazyGetFansQuery();
  const [getBlacks, { data: blackList }] = useLazyGetBlackListQuery();
  const [deleteFollow] = useDeleteFollowMutation();
  const [createFollow] = useCreateFollowMutation();
  const [updateFollow] = useUpdateFollowMutation();
  const [updateFans] = useUpdateFansMutation();

  useEffect(() => {
    getFollows(user.id);
  }, []);

  const handleChangeTab = (index: number) => {
    setTabIndex(index);
    if (index === 0) {
      getFollows(user.id);
    }
    if (index === 1) {
      getFans(user.id);
    }
    if (index === 2) {
      getBlacks(user.id);
    }
  };

  const handleChangeSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  // 加入黑名单
  const handToBlack = async (follow: Follow, type: string) => {
    if (type === "follow") {
      const followData = {
        ...follow,
        permission: 1,
      };
      await updateFollow(followData)
        .unwrap()
        .catch((e) => {
          toast({
            title: (e as ServerError).message,
            position: "top",
            status: "error",
            duration: 2000,
            isClosable: true,
          });
        });
    }

    if (type === "fan") {
      const followData = {
        ...follow,
        permission: 1,
      };
      await updateFans(followData)
        .unwrap()
        .catch((e) => {
          toast({
            title: (e as ServerError).message,
            position: "top",
            status: "error",
            duration: 2000,
            isClosable: true,
          });
        });
    }
  };

  // 不让她看
  const handNotLetLook = async (follow: Follow, type: string) => {
    if (type === "follow") {
      const followData = {
        ...follow,
        permission: 2,
      };
      await updateFollow(followData)
        .unwrap()
        .catch((e) => {
          toast({
            title: (e as ServerError).message,
            position: "top",
            status: "error",
            duration: 2000,
            isClosable: true,
          });
        });
    }

    if (type === "fan") {
      const followData = {
        ...follow,
        permission: 2,
      };
      await updateFans(followData)
        .unwrap()
        .catch((e) => {
          toast({
            title: (e as ServerError).message,
            position: "top",
            status: "error",
            duration: 2000,
            isClosable: true,
          });
        });
    }
  };

  // 不看他
  const handNotLook = async (follow: Follow, type: string) => {
    if (type === "follow") {
      const followData = {
        ...follow,
        permission: 3,
      };
      await updateFollow(followData)
        .unwrap()
        .catch((e) => {
          toast({
            title: (e as ServerError).message,
            position: "top",
            status: "error",
            duration: 2000,
            isClosable: true,
          });
        });
    }

    if (type === "fan") {
      const followData = {
        ...follow,
        permission: 3,
      };
      await updateFans(followData)
        .unwrap()
        .catch((e) => {
          toast({
            title: (e as ServerError).message,
            position: "top",
            status: "error",
            duration: 2000,
            isClosable: true,
          });
        });
    }
  };

  // 取消关注
  const handleCancelFollow = async (follow: Follow) => {
    const followData = {
      ...follow,
      status: 1,
    };
    await deleteFollow(followData)
      .unwrap()
      .catch((e) => {
        toast({
          title: (e as ServerError).message,
          position: "top",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      });
  };
  // 回关
  const handleCreateFollow = async (follow: Follow) => {
    const followData = {
      id: follow.id,
      user_id: follow.user_id,
      followee_id: follow.followee_id,
      create_at: follow.create_at,
      update_at: follow.update_at,
      status: 0,
      permission: follow.permission,
      user: follow.user,
      contents: follow.contents,
    };
    await createFollow(followData)
      .unwrap()
      .catch((e) => {
        toast({
          title: (e as ServerError).message,
          position: "top",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      });
  };

  const handMoveOutBlack = (follow: Follow) => {};

  return (
    <Box overflow={"hidden"}>
      <Box h="100%" width="80%" m="0 auto">
        <Tabs
          mt="12px"
          position="relative"
          variant="unstyled"
          onChange={handleChangeTab}
        >
          <Flex
            h="52px"
            justifyContent={"space-between"}
            borderBottom={"1px solid #E0E0E0"}
          >
            <TabList fontSize={"18px"} color="#8E94A9">
              <Tab _selected={{ color: "#27314D", fontWeight: "bold" }}>
                关注的人
              </Tab>
              <Tab _selected={{ color: "#27314D", fontWeight: "bold" }}>
                粉丝
              </Tab>
              <Tab _selected={{ color: "#27314D", fontWeight: "bold" }}>
                黑名单
              </Tab>
            </TabList>
            <InputGroup flex={1} maxW="400px">
              <Input
                h="40px"
                // w="400px"
                boxSizing="border-box"
                border="1px solid #CBD1DF"
                borderRadius={0}
                bg="none"
                color={"#8E94A9"}
                fontSize="12px"
                placeholder="请输入"
                size="md"
                value={searchValue}
                onChange={handleChangeSearchValue}
              />
              <InputRightElement>
                <SlMagnifier color="#CBD1DF" />
              </InputRightElement>
            </InputGroup>
          </Flex>
          <TabPanels>
            <TabPanel>
              {!followersList?.length && (
                <Flex
                  h="calc(100vh - 180px)"
                  flexDir={"column"}
                  justifyContent="center"
                  alignItems={"center"}
                >
                  <Image src={emptyImg} />
                  <Box fontSize={"16px"} color={"#8E94A9"}>
                    现在您还没有关注的人，赶紧去关注吧～
                  </Box>
                </Flex>
              )}
              {followersList && followersList.length>0 &&
                followersList.map((item) => {
                  return (
                    <Box key={item.id}>
                      <MyFollowing
                        follow={item}
                        FollowType={"follow"}
                        handleCancelFollow={() => handleCancelFollow(item)}
                        handToBlack={() => handToBlack(item, "follow")}
                        handNotLetLook={() => handNotLetLook(item, "follow")}
                        handNotLook={() => handNotLook(item, "follow")}
                      />
                    </Box>
                  );
                })}
            </TabPanel>
            <TabPanel>
              {!fansList?.length && (
                <Flex
                  h="calc(100vh - 180px)"
                  flexDir={"column"}
                  justifyContent="center"
                  alignItems={"center"}
                >
                  <Image src={emptyImg} />
                  <Box fontSize={"16px"} color={"#8E94A9"}>
                    目前您还没有粉丝～
                  </Box>
                </Flex>
              )}
              {fansList && fansList.length>0 &&
                fansList.map((item) => {
                  const hasFollowThisFan = followersList?.some(
                    (obj) => obj.user_id === item.user_id
                  );
                  return (
                    <Box key={item.id}>
                      <MyFollowing
                        follow={item}
                        FollowType={"fan"}
                        hasFollowThisFan={hasFollowThisFan}
                        handleCancelFollow={() => handleCancelFollow(item)}
                        handleCreateFollow={() => handleCreateFollow(item)}
                        handToBlack={() => handToBlack(item, "fan")}
                        handNotLetLook={() => handNotLetLook(item, "fan")}
                        handNotLook={() => handNotLook(item, "fan")}
                      />
                    </Box>
                  );
                })}
            </TabPanel>
            <TabPanel>
              {!blackList?.length && (
                <Flex
                  h="calc(100vh - 180px)"
                  flexDir={"column"}
                  justifyContent="center"
                  alignItems={"center"}
                >
                  <Image src={emptyImg} />
                  <Box fontSize={"16px"} color={"#8E94A9"}>
                    目前您的黑名单空空如也～
                  </Box>
                </Flex>
              )}
              {blackList && blackList.length>0 &&
                blackList.map((item) => {
                  const hasFollowThisFan = followersList?.some(
                    (obj) => obj.user_id === item.user_id
                  );
                  return (
                    <Box key={item.id}>
                      <MyFollowing
                        follow={item}
                        FollowType={"black"}
                        hasFollowThisFan={hasFollowThisFan}
                        handMoveOutBlack={() => handMoveOutBlack(item)}
                      />
                    </Box>
                  );
                })}
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  );
};

export default FollowAndFans;
